import { useEffect, useRef, type KeyboardEvent as EventoTecla, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { M } from '../mensajes/es-PE';

/**
 * Fondo de un diálogo grande, dibujado en la raíz de la página (sobre la barra superior y los
 * paneles). Escape o un clic fuera lo cierran, y los atajos del editor (deshacer, borrar) no actúan
 * mientras está abierto.
 */
export function FondoDialogo({
  alCerrar,
  children,
}: {
  alCerrar: () => void;
  children: ReactNode;
}) {
  const teclas = (e: EventoTecla) => {
    e.stopPropagation();
    if (e.key === 'Escape') alCerrar();
  };
  return createPortal(
    <div
      className="fondo-dialogo"
      onMouseDown={(e) => e.target === e.currentTarget && alCerrar()}
      onKeyDown={teclas}
    >
      {children}
    </div>,
    document.body,
  );
}

export function DialogoConfirmar({
  titulo,
  children,
  textoConfirmar,
  textoCancelar = M.app.cancelar,
  peligro = false,
  alConfirmar,
  alCancelar,
}: {
  titulo: string;
  children: ReactNode;
  textoConfirmar: string;
  textoCancelar?: string;
  peligro?: boolean;
  alConfirmar: () => void;
  alCancelar: () => void;
}) {
  const cancelar = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    cancelar.current?.focus();
    const tecla = (e: KeyboardEvent) => {
      if (e.key === 'Escape') alCancelar();
    };
    window.addEventListener('keydown', tecla);
    return () => window.removeEventListener('keydown', tecla);
  }, [alCancelar]);
  return (
    <div
      className="fondo-dialogo"
      onMouseDown={(e) => e.target === e.currentTarget && alCancelar()}
    >
      <div
        className="panel dialogo"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="titulo-dialogo"
      >
        <h2 id="titulo-dialogo">{titulo}</h2>
        <div className="secundario">{children}</div>
        <div className="acciones">
          <button ref={cancelar} type="button" className="boton" onClick={alCancelar}>
            {textoCancelar}
          </button>
          <button
            type="button"
            className={`boton ${peligro ? 'peligro lleno' : 'principal'}`}
            onClick={alConfirmar}
          >
            {textoConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
}
